import { chartPreviewFromData } from './pptx_chart_preview';
import { CHART_SERIES_COLORS, MAX_CHART_POINTS, MAX_CHART_SERIES } from './presentation_spec';

// Editable chart specs use x/y points; imported PPTX previews use label/value
// caches. Both feed the same bounded renderer, never artifact-supplied SVG.
export function presentationChartPreview(spec, theme) {
  const kinds = { bar: 'barChart', line: 'lineChart', pie: 'pieChart', area: 'areaChart' };
  const kind = kinds[spec?.type];
  if (!kind) return null;
  const palette = [theme?.accent, ...CHART_SERIES_COLORS.slice(1)];
  return chartPreviewFromData({
    kind, title: typeof spec.title === 'string' ? spec.title : '',
    ink: (theme?.text || '').replace(/^#/, ''),
    series: (Array.isArray(spec.series) ? spec.series : []).slice(0, MAX_CHART_SERIES).map((series, index) => ({
      name: series?.name, color: palette[index],
      data: (Array.isArray(series?.data) ? series.data : []).slice(0, MAX_CHART_POINTS)
        .map(point => ({ label: point?.x, value: point?.y })),
    })),
  });
}
